import React from "react";
import Button from "../../../../components/common/button/Button";
import { Form, Formik } from "formik";
import Input from "../../../../components/common/inputs/Input";
import { postApi } from "../../../../services/api/globalApi";
import { successMessage } from "../../../../utils/toastify-message/ToastifyMessage";
import { globalDiscountValidation } from "../../../../utils/validations/discount/globalDiscountValidation";

function GlobalDiscount({ data }) {
  const formHandler = async (values, { resetForm }) => {
    const path = "admin/discounts";
    const body = {
      globalDiscount: {
        percent: values.percent,
      },
    };
    try {
      await postApi({ path, body });
      successMessage("تخفیف با موفقیت بروزرسانی شد.");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="w-full py-4 px-4 border-r border-l">
      <Formik
        enableReinitialize
        initialValues={{
          percent: data?.percent || "",
        }}
        validationSchema={globalDiscountValidation}
        onSubmit={formHandler}
      >
        <Form>
          <div className="grid gap-6 mb-4 md:grid-cols-2">
            <Input name="percent" placeholder="درصد" label="درصد" type="text" />
            <div className="flex flex-col mt-8 gap-y-2">
              <div className="">
                <Button text={"بروزرسانی تخفیف"} color={"success"} />
              </div>
            </div>
          </div>
        </Form>
      </Formik>
    </div>
  );
}

export default GlobalDiscount;
